// import { useState } from 'react';
import CourseList from '../../components/CourseList';
import Box from "@mui/material/Box";
// import axiosInstance from "../../helpers/Axios";
import type { IContact } from '../../interfaces/IContact';
import type { ICourse } from '../../interfaces/ICourse';
import { useCourses } from '../../contexts/CourseContext';
import Typography from '@mui/material/Typography';

// import { Link } from 'react-router-dom';
// import DisplayHorairesForm from '../../components/DisplayHorairesForm';


// const defaultList: ICourseObj[] = [];


interface ICourseObj {
    course: ICourse;
    subscribes: IContact[];
}

interface CourseContextType {
    list: ICourseObj[];
    loading: boolean;
}
const Horaires = () => {
    const courseContext: CourseContextType = useCourses();

    // // const [list, setList] = useState(defaultList);
    // const [visible, setVisible] = useState(false);
    // setVisible(courseContext.list !== undefined && courseContext.list.length > 0);
    // const loading = list === defaultList && visible;

    // useEffect(() => {
    //     if (loading)
    //         axiosInstance.get("/course")
    //             .then(response => {
    //                 //console.log('response', response);

    //                 setList(response.data);//.map((courseObj : ICourseObj) => courseObj.course))
    //                 // setUserProfile(response.data);
    //                 // setLocation(response.data.location);
    //             })
    //             .catch((err) => {
    //                 const error = err.response === undefined ?
    //                     'Server in not reachable'
    //                     : err.response.data;
    //                 console.log('error', error);
    //                 setVisible(false);
    //             });
    // }
    // );

    return (
        <div id="horaires">
            <div id="title">
                <h1>Les horaires</h1>
            </div>
            <Box id="content">
                <div id="aaaaa" className="column-content">

                    <Typography variant="h4" component="h2">
                        <strong>
                            Les cours de septembre 2025 à juin 2026
                        </strong>
                    </Typography>
                    {/* <h1 className="right"><span className="color-black small"><strong>Les cours de septembre 2025 à juin 2026</strong></span></h1> */}

                    <p>
                        <span className="small">
                            <strong>
                                <a href="/images/courses/horaires.jpg" rel="iframe" title="image horaires" className="fancybox" data-fancybox-type="image">
                                    <img alt="garçon en porté" className="img-center margin-leftright-auto block" height="172" src="/images/courses/horaires.jpg?fx=r_200_200" width="218" />
                                </a>
                            </strong>
                        </span>
                    </p>
                    <h3>Les nouveaux horaires de la saison 2025-2026</h3>
                    {/* <p className="align-center"><span className="small"><strong><span className="big">&nbsp;<span className="color-f1c40f"></span></span></strong></span></p> */}

                    <p className="align-center"><span className="font-size: 16px;"><strong>Plusieurs cours sont déclinés en différents niveaux: niveau 1= débutant, niveau 2= avancé </strong></span></p>

                    <p className="align-center"><span className="font-size: 16px;"><strong>Les cours reprennent la semaine du 15 septembre 2025</strong></span></p>

                    {/* <p className="align-center">&nbsp;</p> */}

                    {/* <h1><span className="small">&nbsp;</span><span className="color-black"><span className="small"><strong>&nbsp;&nbsp;</strong><strong>&nbsp;&nbsp;&nbsp;</strong></span></span></h1> */}
                    {/* align="left" border="0" */}

                    {/* <p>L'horaire n'est pas encore définitif, il sera confirmé prochainement.</p> */}

                    {
                        courseContext.loading ?
                            <p>Chargement en cours...</p>
                            :
                            courseContext.list.length > 0 ?
                                <div className="flex flex-wrap flex-space-between">
                                    <CourseList stages={undefined} courses={courseContext.list} title="Liste des cours" />
                                </div>
                                :
                                <div>
                                    <p>Le système d'inscription est actuellement en panne.</p>
                                </div>

                    }


                    {/* {
                        courseContext.loading ?
                            <p>Chargement en cours...</p>
                            :
                            visible ?
                                <div className="flex flex-wrap flex-space-between">
                                    <CourseList stages={undefined} courses={courseContext.list} title="Liste des cours" />
                                </div>
                                :
                                <div>
                                    <p>Le système d'inscription est actuellement en panne.</p>
                                </div>
                    }  */}
                </div>

            </Box>
        </div>
    )
};

export default Horaires;
